import React from 'react';
import { OnboardingFlow } from './pages/OnboardingFlow';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <OnboardingFlow data-id="element-1" />
    </div>;
}